module.exports = __webpack_public_path__ + "static/media/icon-stack-of-money.7ab623d8.svg";